import { render } from "./ZhCompile.vue?vue&type=template&id=3687dcc6"
import script from "./ZhCompile.vue?vue&type=script&lang=js"
export * from "./ZhCompile.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__